import React from "react";
import { Table } from "reactstrap";
import { object } from "prop-types";
import "./clientScoringInputParametersTable.css";

const ClientScoringInputParametersTable = ({ singleClientReportDetails }) => {
  const rows = singleClientReportDetails.scoringInputData.map((entry) => (
    <tr key={entry.name}>
      <td className="font-weight-bolder">{entry.name}</td>
      <td>{entry.value}</td>
    </tr>
  ));
  return (
    <Table className="single-client-report-entries-table-scoring-input">
      <thead>
        <tr>
          <th>{singleClientReportDetails.nameLabel}</th>
          <th>{singleClientReportDetails.valueLabel}</th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
      <tfoot />
    </Table>
  );
};
ClientScoringInputParametersTable.propTypes = {
  singleClientReportDetails: object.isRequired,
};

export default ClientScoringInputParametersTable;



// WEBPACK FOOTER //
// ./src/features/reports/components/single-client-details/scoring-input-parameters-table/ClientScoringInputParametersTable.jsx